/** Crognaleto: sede municipio = frazione Nerito — una sola scheda foto/storia. */

export const CROGNALETO_SLUG = "crognaleto";
export const CROGNALETO_NERITO_FRAZIONE_SLUG = "crognaleto__nerito";
export const CROGNALETO_TERRITORY_HERO = "/hero/crognaleto-borgo-vista-laga.png";

const NERITO_PREFIXES = ["frazione-nerito-", "crogn-nerito-", "crogn-stor-nerito-"];

export function isNeritoMunicipioMediaUrl(url) {
  if (!url || typeof url !== "string") return false;
  const low = url.trim().toLowerCase();
  if (!low.includes("nerito")) return false;
  const name = low.split("/").pop() || "";
  if (NERITO_PREFIXES.some((p) => name.startsWith(p))) return true;
  return name.includes("nerito");
}

export function stripNeritoMediaFromComuneRecord(c) {
  if (!c || String(c.slug || "").toLowerCase() !== CROGNALETO_SLUG) return c;
  const gallery = (Array.isArray(c.gallery) ? c.gallery : []).filter(
    (u) => u && !isNeritoMunicipioMediaUrl(u),
  );
  let image = c.image || c.hero_image || "";
  let hero_image = c.hero_image || c.image || "";
  if (isNeritoMunicipioMediaUrl(image)) {
    image = gallery[0] || CROGNALETO_TERRITORY_HERO;
  }
  if (isNeritoMunicipioMediaUrl(hero_image)) {
    hero_image = gallery[0] || CROGNALETO_TERRITORY_HERO;
  }
  if (!image && !hero_image) {
    image = CROGNALETO_TERRITORY_HERO;
    hero_image = CROGNALETO_TERRITORY_HERO;
  }
  return { ...c, gallery, image, hero_image };
}
